import i18n from 'src/i18n';
import Tables from 'src/class/Tables';

const configTable2 = () => {
    const TableLog = { ...Tables.Table };

    TableLog.tableColumns = [
        {
            prop: 'duration_human',
            label: i18n.t('audit.total_duration'),
            align: 'center',
            sortable: true,
        },
        {
            prop: 'login_at_local',
            label: i18n.t('audit.login_date'),
            align: 'center',
        },
        {
            prop: 'logout_at_local',
            label: i18n.t('audit.logout_date'),
            align: 'center',
        },
        {
            prop: 'logout_type',
            label: i18n.t('audit.logout_type'),
        },
    ];

    const SearchLog = {
        /**
      * Meotodos modoficados y diferente al por defecto de la clase Tables.js ya que
      * generaba un loop infinito por la forma que se accedia el queriedDataLog en las
      * actualizaciones de la paginacion, la solucion fue realizar esta paginacion manualmente
      * desde la propia vista y no desde este metodo
      */
        pagedDataLog() {
            return this.tableDataLog.slice(this.fromLog, this.toLog);
        },

        queriedDataLog() {
            let result = this.tableDataLog;

            if (this.searchQueryLog !== '' && this.fuseSearchLog) {
                const fuseResult = this.fuseSearchLog.search(
                    '=' + this.searchQueryLog + ''
                );

                result = fuseResult.map(function (r) {
                    return r && r.item ? r.item : r;
                });
            }

            return result.slice(this.fromLog, this.toLog);
        },

        toLog() {
            let highBound = this.fromLog + this.paginationLog.perPage;
            if (this.totalLog < highBound) {
                highBound = this.totalLog;
            }

            return highBound;
        },

        fromLog() {
            let from =
                this.paginationLog.perPage * (this.paginationLog.currentPage - 1);

            return from;
        },

        totalLog() {
            let result = this.tableDataLog;

            if (this.searchQueryLog !== '' && this.fuseSearchLog) {
                const fuseResult = this.fuseSearchLog.search(
                    '=' + this.searchQueryLog + ''
                );

                result = fuseResult.map(function (r) {
                    return r && r.item ? r.item : r;
                });
            }

            return result.length;
        },
    };


    return { TableLog, SearchLog };
};

export default configTable2;
